import { Locale } from '@rover/constants/src/i18n/lingui.constants';
import type { LocalizedFormatFunction } from '@rover/types/src/LocalizedFormatFunction';

function generateExternalFormatMap(
  getLocalizedFormat: LocalizedFormatFunction,
  locale?: Locale
): Record<string, string> {
  return {
    'M/DD': getLocalizedFormat('MONTH_DAY_SHORT', locale),
  };
}

export default generateExternalFormatMap;
